import { render } from "./TrainerData.vue?vue&type=template&id=4899f91e"
import script from "./TrainerData.vue?vue&type=script&lang=js"
export * from "./TrainerData.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__